import React from 'react';
import GroupIcon from '@mui/icons-material/Group';
import LinearProgress from '@mui/material/LinearProgress';
import Divider from '@mui/material/Divider';

import { CircularProgress } from '@mui/material';

const RoleSummary = ({ loading, userCounts }) => {
  return (
    <div className="UserSummary">
      <div className="summaryContainer">
        <div className="summary">
          <div className="number">{loading ? <CircularProgress size={30} /> : userCounts.activeUserCount}</div>
          <div className="text">Active Users</div>
        </div>
        <div className="icon">
          <GroupIcon color="primary" fontSize="large" />
        </div>
      </div>
      <Divider />
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Basic:</div> <div>{loading ? <CircularProgress size={10} /> : userCounts.basicUserCount}</div>
        </div>
        <LinearProgress
          variant="determinate"
          value={loading ? 0 : (userCounts.basicUserCount / userCounts.activeUserCount) * 100}
          title={loading ? 0 : `${Math.floor((userCounts.basicUserCount / userCounts.activeUserCount) * 100)}%`}
        />
      </div>
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Standard:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : userCounts.standardUserCount}</div>
        </div>
        <LinearProgress
          variant="determinate"
          value={loading ? 0 : (userCounts.standardUserCount / userCounts.activeUserCount) * 100}
          title={loading ? 0 : `${Math.floor((userCounts.standardUserCount / userCounts.activeUserCount) * 100)}%`}
        />
      </div>
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Premium:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : userCounts.premiumUserCount}</div>
        </div>
        <LinearProgress
          variant="determinate"
          value={loading ? 0 : (userCounts.premiumUserCount / userCounts.activeUserCount) * 100}
          title={loading ? 0 : `${Math.floor((userCounts.premiumUserCount / userCounts.activeUserCount) * 100)}%`}
        />
      </div>
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Professional: </div>
          <div>{loading ? <CircularProgress size={10} /> : userCounts.professionalUserCount}</div>
        </div>
        <LinearProgress
          variant="determinate"
          value={loading ? 0 : (userCounts.professionalUserCount / userCounts.activeUserCount) * 100}
          title={loading ? 0 : `${Math.floor((userCounts.professionalUserCount / userCounts.activeUserCount) * 100)}%`}
        />
      </div>
    </div>
  );
};

export default RoleSummary;
